import React from 'react';
import NavBar from '../components/layout/NavBar';
import SiteFooter from '../components/layout/SiteFooter';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { webPageSchema, breadcrumbSchema } from '../schema';
import { CONTACT_EMAIL, LEGAL_ENTITY_NAME, LEGAL_ADDRESS, LEGAL_JURISDICTION } from '../seoConfig';

const Privacy = () => (
  <div className="relative w-full min-h-screen">
    <SEO
      title="Privacy Policy"
      description="How SaniQ collects, uses, and protects the personal information submitted through this website."
      path="/privacy"
      schema={[
        webPageSchema({ title: 'Privacy Policy', description: 'SaniQ privacy policy.', path: '/privacy' }),
        breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Privacy Policy', path: '/privacy' }]),
      ]}
    />
    <NavBar />
    <Breadcrumbs trail={[{ name: 'Home', path: '/' }, { name: 'Privacy Policy', path: '/privacy' }]} />

    <section className="py-12 px-8 max-w-3xl mx-auto">
      <h1 className="text-3xl md:text-4xl font-light text-white mb-3">Privacy Policy</h1>
      <p className="text-white/40 text-sm mb-10">Effective date: 22 April 2026</p>

      <div className="space-y-6 text-sm text-white/60 leading-relaxed">
        <p>
          This Privacy Policy is issued by {LEGAL_ENTITY_NAME ? `${LEGAL_ENTITY_NAME}, trading as SaniQ` : 'SaniQ'}, based in {LEGAL_ADDRESS} (&ldquo;SaniQ,&rdquo; &ldquo;we,&rdquo; &ldquo;us&rdquo;). It explains how we handle personal information collected through this website, in accordance with applicable privacy law in {LEGAL_JURISDICTION}.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Information We Collect</h2>
        <p>SaniQ collects the email address you voluntarily submit through the waitlist registration form or newsletter signup on this website.</p>

        <h2 className="text-white text-lg font-medium pt-4">How We Use Your Information</h2>
        <p>
          We use this information only to provide launch updates, early access information, and relevant product communication.
          We do not sell your personal information to third parties.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Service Providers</h2>
        <p>
          We may use service providers (such as form and email platforms) to process your submission securely on our behalf.
          These providers are permitted to use your information only for providing services to SaniQ.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Your Consent &amp; Choices</h2>
        <p>
          By submitting the form, you consent to receive product-related communications from SaniQ. You can request removal
          from future communications at any time by replying to an email from us or contacting us directly.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Data Retention &amp; Security</h2>
        <p>
          We take reasonable steps to protect submitted data, but no method of transmission over the internet is 100% secure.
          We retain your information only for as long as required for the purposes described above.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Contact Us</h2>
        <p>
          For privacy questions or data removal requests, contact us at{' '}
          <span className="text-cyan-400">{CONTACT_EMAIL}</span>
          .
        </p>
      </div>
    </section>

    <SiteFooter />
  </div>
);

export default Privacy;
